/* Motion pack icons: loop continuously while on screen, pause when scrolled away. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var loaded = {};

  // Download the sprite before switching to it so there is no blank flash.
  function ready(icon, cb) {
    if (icon.classList.contains('is-live')) return cb();
    var src = icon.getAttribute('data-fpm');
    if (loaded[src]) { icon.classList.add('is-live'); return cb(); }
    var img = new Image();
    img.onload = function () { loaded[src] = true; icon.classList.add('is-live'); cb(); };
    img.src = src;
  }

  function play(icon, once) {
    ready(icon, function () {
      icon.classList.remove('is-playing', 'is-once');
      void icon.offsetWidth; // restart from the first frame
      icon.classList.add('is-playing');
      if (once) icon.classList.add('is-once');
    });
  }

  function stop(icon) {
    icon.classList.remove('is-playing', 'is-once');
  }

  function icons(host) {
    return host.querySelectorAll('.fpm[data-fpm]:not([data-fpm-autoplay])');
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      icons(e.target).forEach(function (i) {
        if (e.isIntersecting) { if (!i.classList.contains('is-playing')) play(i, false); }
        else stop(i);
      });
    });
  }, { rootMargin: '100px 0px' }) : null;

  // One-shot icons wait until they are on screen, then play once and hold.
  var onceIo = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      onceIo.unobserve(e.target);
      play(e.target, true);
    });
  }, { threshold: 0.5 }) : null;

  function bindHost(host) {
    if (host.__fpm) return;
    host.__fpm = true;
    if (io) io.observe(host);
    else icons(host).forEach(function (i) { play(i, false); });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-fpm-host]').forEach(bindHost);
    (root || document).querySelectorAll('.fpm[data-fpm-autoplay="once"]').forEach(function (i) {
      if (i.__fpm) return;
      i.__fpm = true;
      if (!onceIo) return play(i, true);
      onceIo.observe(i);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  // Re-bind when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
